/**
 * Japanese translations
 */
import { Translations } from './en';

export const ja: Translations = {
  // Landing Page
  landing: {
    title: 'KEYBOARD VISUALIZER',
    subtitle: '指先に、思考の速さを。',
    description: '1,300以上のショートカットをリアルタイムに可視化。ブラウザ上で動作する最高峰の練習プラットフォームで、クリエイティブな時間を最大化しましょう。',
    ctaButton: '今すぐ無料で始める',

    stats: {
      shortcuts: 'ショートカット収録数',
      apps: '対応アプリケーション',
      levels: '難易度ステップ',
    },

    whyTitle: '選ばれる理由',

    features: {
      visualFeedback: {
        title: '圧倒的な視覚体験',
        description: '打鍵した全てのキーを美しく可視化。脳と指の連携を深め、直感的に操作を記憶できます。',
      },
      quizMode: {
        title: '実践的なクイズ形式',
        description: '忘却曲線に基づいた反復練習。苦手な項目をAIが分析し、効率的な学習をサポートします。',
      },
      multiPlatform: {
        title: '主要アプリを網羅',
        description: 'VS Code, Excel, SlackからGmailまで。プロが毎日使うツールの全てをマスターできます。',
      },
      dashboard: {
        title: '学習ダッシュボード',
        description: '統計の視覚化やパフォーマンスチャートで進捗を可視化。AIが苦手な項目を自動分析します。',
      },
      conflictDetection: {
        title: '競合の自動検出',
        description: 'アプリとブラウザのショートカット競合を自動的に検出し、リアルタイムで解決策を提示します。',
      },
      sequentialInput: {
        title: '順押し入力への対応',
        description: 'Ctrl + K, Ctrl + S のような連続したキー入力が必要な高度なショートカットにも完全対応しています。',
      },
    },

    appsTitle: '対応アプリケーション',
    appsDescription: 'エンジニア、デザイナー、ビジネスパーソンのための主要ツールを完備',

    benefitsTitle: '習得することで得られる価値',
    benefits: {
      productivity: {
        number: '01',
        title: '圧倒的な生産性向上',
        description: 'マウス操作をキーボードに置き換えることで、作業スピードは平均30〜50%向上します。',
      },
      flow: {
        number: '02',
        title: '深い集中状態（フロー）の維持',
        description: '視線と手の移動を最小限に抑えることで、思考の断絶を防ぎ、没入感を維持できます。',
      },
      skill: {
        number: '03',
        title: 'プロフェッショナルの証',
        description: '流れるようなキーボード操作は、周囲にプロとしての信頼感と洗練された印象を与えます。',
      },
      ergonomics: {
        number: '04',
        title: '疲労の軽減と健康',
        description: 'マウスの多用による肩こりや手首の負担を軽減し、長時間の作業も快適になります。',
      },
    },

    targetTitle: 'こんな方におすすめ',
    targets: {
      engineer: {
        title: 'エンジニア / 開発者',
        description: 'エディタ操作を高速化し、コードを書くことに集中したい方。',
      },
      designer: {
        title: 'デザイナー / クリエイター',
        description: 'ツール切り替えを無意識化し、創造性を妨げたくない方。',
      },
      business: {
        title: 'ビジネスパーソン',
        description: '資料作成やメール対応を最速で終わらせ、価値ある仕事に時間を使いたい方。',
      },
    },

    faqTitle: 'よくある質問',
    faqs: [
      {
        q: '本当に無料で使えますか？',
        a: 'はい、全ての機能を無料でご利用いただけます。アカウント登録なしでもすぐに学習を始められます。'
      },
      {
        q: '特定のOS専用のショートカットも学べますか？',
        a: 'WindowsとmacOSの両方に対応しており、設定からお使いの環境に合わせて切り替えが可能です。'
      },
      {
        q: 'インストールは必要ですか？',
        a: '不要です。ブラウザ上で全ての機能が動作するため、場所を選ばず練習できます。'
      }
    ],

    testimonialsTitle: 'お客様の声',
    testimonials: [
      {
        name: 'S.K様 (エンジニア)',
        comment: 'VS Codeのショートカットが全然覚えられなかったのですが、このアプリのおかげで1週間で主要なものはマスターできました。開発スピードが劇的に上がりました！',
        rating: 5,
      },
      {
        name: 'M.T様 (デザイナー)',
        comment: '視覚的にキーが表示されるのがとても分かりやすいです。FigmaやPhotoshopの練習にも使いたいですね。クイズ形式なので飽きずに続けられます。',
        rating: 5,
      },
      {
        name: 'Y.S様 (大学生)',
        comment: 'ブラウザでサクサク動くので、ちょっとした空き時間に練習しています。タイピング速度だけでなく、ショートカットを覚えることでパソコン操作全般が速くなりました。',
        rating: 4,
      },
      {
        name: 'S.I様 (事務職)',
        comment: 'Excelのショートカットを覚えるために使い始めました。マウスに手を伸ばす回数が減り、肩こりも少し楽になった気がします（笑）',
        rating: 5,
      },
      {
        name: 'K.O様 (ライター)',
        comment: 'ブラウザやエディタの操作が劇的にスムーズになりました。特にタブ管理やテキスト編集のショートカットは、執筆作業の集中力を削がないために不可欠です。',
        rating: 5,
      },
      {
        name: 'T.N様 (システム管理者)',
        comment: 'MacとWindows、両方のOSを使うのでショートカットが混乱しがちでしたが、このツールで効率的に学習できるようになりました。切り替え時のストレスが激減です！',
        rating: 5,
      },
    ],

    howItWorksTitle: '使い方は簡単',
    steps: {
      step1: {
        number: 'STEP 1',
        title: 'アプリを選択',
        description: '学習したいアプリケーションとレベルを選びます',
      },
      step2: {
        number: 'STEP 2',
        title: 'キーを押す',
        description: '実際にキーボードでショートカットを入力します',
      },
      step3: {
        number: 'STEP 3',
        title: '即座にフィードバック',
        description: '正解・不正解が瞬時に表示され、理解が深まります',
      },
    },

    releaseNotesTitle: '最新アップデート',
    releaseNotesDescription: 'Keyboard Visualizerの最新機能と改善履歴',
    viewAllReleases: 'すべてのリリースノートを見る →',

    finalCtaTitle: '今すぐ始めて、生産性を最大化しましょう',
    finalCtaDescription: '完全無料・登録不要で、すぐに使い始められます',
    finalCtaButton: '無料で今すぐはじめる',

    footer: {
      copyright: 'Keyboard Visualizer. All rights reserved.',
    },
  },

  // App Header
  header: {
    title: 'Keyboard Visualizer',
    login: 'ログイン',
    logout: 'ログアウト',
    profile: 'プロフィール',
    settings: '設定',
    releaseNotes: 'リリースノート',
    backToHome: 'ホームに戻る',
    backToLP: 'LPに戻る',
    quizMode: 'Quiz Mode',
    visualizer: 'Visualizer',
    fullscreen: '全画面',
    exitFullscreen: '全画面終了',
    csvDownload: 'CSVダウンロード',
    noShortcutsToDownload: 'ダウンロードするショートカットがありません',
    returnToVisualizer: 'ビジュアライザーに戻ります',
    startQuizMode: 'クイズモードを開始します',
    keyboardLayout: 'キーボード配列',
  },

  // Setup Screen
  setup: {
    title: 'キーボードビジュアライザー',
    subtitle: 'ショートカット学習ツール',
    welcome: 'ようこそ！',
    welcomeMessage: '1,300種類以上のショートカットを可視化・練習しましょう',
    loginButton: 'ログイン',
    loginTooltip: 'ログインしてクイズの進捗を保存',
    selectLanguage: '言語を選択してください',
    selectDisplayMode: '表示モードを選択してください',
    selectKeyboardLayout: 'キーボードレイアウトを選択してください',
    selectMode: 'モードを選択してください',
    selectApplication: 'アプリケーションを選択してください（複数選択可）',
    selectQuizApplication: 'クイズ用アプリを選択してください',
    selectDifficulty: '難易度を選択してください',
    confirmButton: '確定',
    randomApp: 'ランダム',
    pleaseSelectDisplayMode: '表示モードを選択してください',
    pleaseSelectLayout: 'キーボードレイアウトを選択してください',
    pleaseSelectMode: 'モードを選択してください',
    pleaseSelectApp: 'アプリケーションを選択してください',
    pleaseSelectDifficulty: '難易度を選択してください',
    pleaseSelectQuizApp: '出題するアプリケーションを選択してください',
    canChangeInSettings: '後で設定から変更できます',
    displayMode: {
      fullscreen: {
        title: '全画面モード',
        description: 'フルスクリーン表示で集中して学習',
        recommendation: '💡 推奨：より没入感のある学習体験',
      },
      windowed: {
        title: 'ウィンドウモード',
        description: '他のウィンドウと並べて使用',
      },
    },
    keyboardLayout: {
      windowsJis: {
        title: 'Windows JIS',
        description: '日本語キーボード（Windows）',
      },
      windowsUs: {
        title: 'Windows US',
        description: 'US（英語）キーボード（Windows）',
      },
      macJis: {
        title: 'Mac JIS',
        description: '日本語キーボード（Mac）',
      },
      macUs: {
        title: 'Mac US',
        description: 'US（英語）キーボード（Mac）',
      },
    },
    modes: {
      visualizer: {
        title: 'ビジュアライザーモード',
        description: 'キーボードショートカットを可視化',
      },
      quiz: {
        title: 'クイズモード',
        description: 'ショートカットを学習してスコアを競う',
      },
    },
    difficulty: '難易度',
    difficultyOptions: {
      basic: {
        name: 'basic',
        description: '初心者向け：よく使う基本的なショートカット',
      },
      standard: {
        name: 'standard',
        description: '中級者向け：標準的な難易度のショートカット',
      },
      hard: {
        name: 'hard',
        description: '上級者向け：より高度で実用的なショートカット',
      },
      madmax: {
        name: 'madmax',
        description: 'エキスパート向け：非常に専門的で難易度の高いプロフェッショナルなショートカット',
      },
      allrange: {
        name: 'allrange',
        description: '全難易度：すべてのレベルからランダムにショートカットを出題',
      },
    },
    start: 'スタート',
    back: '戻る',
  },

  // Quiz
  quiz: {
    title: 'クイズモード',
    question: '問題',
    score: 'スコア',
    progress: '進捗',
    inputShortcut: 'この操作のショートカットを入力してください',
    correct: '正解！',
    incorrect: '不正解',
    skip: 'スキップ',
    next: '次へ',
    nextQuestion: '次の問題へ →',
    finish: '終了',
    pause: '一時停止',
    resume: '再開',
    paused: '一時停止中',
    sequential: '順序押し',
    pressKeysInOrder: 'キーを順番に押してください（Alt を押したまま順番に押す）',
    pressCorrectShortcut: '正しいショートカットキーを押してください',
    questionFormat: '【{app}】{description}のショートカットは？',
    typing: '入力中...',
    yourAnswer: 'あなたの回答：',
    correctAnswer: '正解は：',
    otherCorrect: '他の正解：',
    results: {
      title: 'クイズ結果',
      yourScore: 'あなたのスコア',
      correctAnswers: '正解数',
      totalQuestions: '総問題数',
      accuracy: '正答率',
      tryAgain: 'もう一度挑戦',
      backToSetup: 'セットアップに戻る',
      quizComplete: '🎉 クイズ終了！',
      difficultShortcuts: '苦手なショートカット',
      mistakesCount: '回ミス',
      retryQuiz: '🔄 もう一度挑戦',
      shareResults: '🔗 結果をシェア',
      copied: '✅ コピーしました！',
      selectOtherQuiz: '📝 他のクイズモードを選ぶ',
      backToStart: '🏠 スタートに戻る',
      shareText: 'キーボード早打ちクイズで【{app}】のスコアは {totalQuestions}問中{correctAnswers}問正解でした！ 正答率: {accuracy}% #キーボードビジュアライザー',
    },
  },

  // Normal Mode (Visualization)
  normalMode: {
    title: 'ビジュアライズモード',
    pressKeys: 'キーボードショートカットを入力してください',
    pressAnyKey: 'キーを押してください...',
    noMatch: '一致するショートカットがありません',
    noShortcutFound: 'ショートカットが見つかりません',
    protectedShortcut: 'これはシステムで保護されたショートカットです',
    fullscreenHint: 'F11キーを押してフルスクリーンモードにすると、より多くのショートカットをキャプチャできます',
    applicationSelector: 'アプリケーション',
    difficultyFilter: '難易度フィルター',
    selectAll: '全選択',
    deselectAll: '全解除',
    selectAtLeastOne: '⚠️ 少なくとも1つの難易度を選択してください',
    availableShortcuts: '利用可能なショートカット',
    singleKeyShortcuts: '単独キーショートカット',
    gmailSingleKeyShortcuts: 'Gmail 単独キーショートカット',
    sequential: '順押し',
    browserConflict: 'ブラウザ競合',
    browserConflictWarning: 'ブラウザショートカット競合',
    browserConflictDescription: 'このキーはChromeブラウザのショートカットと競合する可能性があります（全画面モードで解消）',
    preventableInFullscreen: '全画面で防げる',
    systemProtected: 'システム保護',
    difficultyDescriptions: {
      basic: '日常的な基本操作',
      standard: '標準的なショートカット',
      hard: '高度な機能と操作',
      madmax: 'エキスパートレベルのショートカット',
    },
  },

  // Shortcut Card
  shortcutCard: {
    basic: '基本',
    standard: '標準',
    hard: '上級',
    madmax: 'マッドマックス',
    windows: 'Windows',
    mac: 'macOS',
    crossPlatform: 'クロスプラットフォーム',
    protected: 'システム保護',
    preventableInFullscreen: 'フルスクリーンで防止可能',
    browserConflict: 'ブラウザショートカットと競合（全画面モードで解消）',
  },

  // Authentication
  auth: {
    signIn: 'ログイン',
    signUp: 'アカウント作成',
    signOut: 'ログアウト',
    passwordReset: 'パスワードをリセット',
    email: 'メールアドレス',
    password: 'パスワード',
    confirmPassword: 'パスワード（確認）',
    displayName: '表示名',
    forgotPassword: 'パスワードをお忘れですか？',
    noAccount: 'アカウントをお持ちでないですか？',
    haveAccount: 'すでにアカウントをお持ちですか？',
    signInWith: 'ログイン',
    signInWithGoogle: 'Googleでログイン',
    connectingToGoogle: 'Googleに接続中...',
    google: 'Google',
    github: 'GitHub',
    or: 'または',
    emailSignIn: 'メールアドレスでログイン',
    loading: '読み込み中...',
    processing: '処理中...',
    sendResetLink: 'リセットリンクを送信',
    backToSignIn: 'ログインに戻る',
    subtitle: 'アカウントを作成してクイズの進捗とスコアを保存しましょう',
    passwordResetSubtitle: '登録済みのメールアドレスを入力してください。パスワードリセットのリンクをお送りします。',
    passwordResetTitle: 'パスワードリセット',
    newPasswordLabel: '新しいパスワード',
    confirmPasswordLabel: '新しいパスワード（確認用）',
    resetPasswordButton: 'パスワードをリセット',
    setNewPasswordMessage: '新しいパスワードを設定してください。',
    linkInvalidError: 'パスワードリセットのリンクが無効または期限切れです。\n再度パスワードリセットをリクエストしてください。',
    resetSuccessMessage: 'パスワードが正常にリセットされました。\n3秒後に自動的にホーム画面に移動します。',
    confirmationEmailSent: '確認メールを送信しました。メールを確認してアカウントを有効化してください。',
    passwordResetEmailSent: 'パスワードリセットのメールを送信しました。メールを確認してください。',
    signOutError: 'ログアウトに失敗しました。もう一度お試しください。',
    displayNamePlaceholder: '例: 田中太郎',
    passwordPlaceholder: '6文字以上',
    myPage: 'マイページ',
    defaultUserName: 'ユーザー',
    error: {
      invalidEmail: '無効なメールアドレスです',
      weakPassword: 'パスワードは6文字以上である必要があります',
      passwordMismatch: 'パスワードが一致しません',
      userNotFound: 'ユーザーが見つかりません',
      wrongPassword: 'パスワードが正しくありません',
      emailInUse: 'このメールアドレスは既に使用されています',
      unknownError: 'エラーが発生しました。もう一度お試しください。',
      invalidCredentials: 'メールアドレスまたはパスワードが正しくありません。',
      emailNotConfirmed: 'メールアドレスが確認されていません。確認メールを確認してください。',
      userExists: 'このメールアドレスは既に登録されています。',
      passwordTooShort: 'パスワードは6文字以上である必要があります。',
      rateLimit: 'リクエストが多すぎます。しばらく待ってからもう一度お試しください。',
      sessionInvalid: 'セッションが無効です。再度ログインしてください。',
      oauthCancelled: 'ログインがキャンセルされました。',
      oauthProviderError: 'ソーシャルログインプロバイダーでエラーが発生しました。',
      serverError: 'サーバーエラーが発生しました。しばらく待ってからもう一度お試しください。',
      temporarilyUnavailable: '一時的にログインできません。しばらく待ってからもう一度お試しください。',
      invalidRequest: '無効なリクエストです。もう一度お試しください。',
      unauthorizedClient: 'ログインプロバイダーが正しく設定されていません。管理者に連絡してください。',
      invalidScope: 'アクセス許可の設定に問題があります。管理者に連絡してください。',
      genericSocialError: 'ソーシャルログイン中にエラーが発生しました。',
    },
  },

  // User Menu
  user: {
    welcome: 'ようこそ',
    myProfile: 'マイプロフィール',
    quizHistory: 'クイズ履歴',
    statistics: '統計',
    settings: '設定',
    signOut: 'ログアウト',
  },

  // Statistics
  stats: {
    totalSessions: '総セッション数',
    averageScore: '平均スコア',
    totalCorrect: '総正解数',
    totalQuestions: '総問題数',
    overallAccuracy: '総合正答率',
    lastQuiz: '最終クイズ',
    noData: 'クイズ履歴がありません',
  },

  // My Page Components
  myPage: {
    dashboard: 'ダッシュボード',
    welcomeBack: '学習の進捗をひと目で確認しましょう',
    backToApp: '🏠 アプリへ戻る',
    statsSummary: '📊 統計サマリー',
    appPerformanceTitle: '📈 アプリ別パフォーマンス',
    weakShortcutsTitle: '⚠️ 重点復習ショートカット',
    bookmarkedShortcutsTitle: '⭐ ブックマーク',
    startBookmarkedDrill: 'ブックマーク項目を練習',
    noBookmarks: 'ブックマークしたショートカットはありません。',
    appStatsTitle: '📱 アプリケーション別統計',
    recentHistoryTitle: '🎯 最近のプレイ履歴',
    profileTitle: '👤 プロフィール',
    avatarAlt: 'アバター',
    edit: '編集',
    uploadConfirm: 'アップロード確定',
    uploading: 'アップロード中...',
    uploadSuccess: 'アバターが正常にアップロードされました！',
    displayNamePlaceholder: '表示名',
    displayNameUpdated: '表示名が更新されました！',
    displayNameEmpty: '表示名は空白にできません。',
    bioPlaceholder: '自己紹介（例: ショートカットを極めてエンジニアとしての生産性を上げたいです）',
    goalPlaceholder: '目標（例: Excelのショートカットをすべてマスターする）',
    bioLabel: '自己紹介',
    goalLabel: '目標',
    profileUpdated: 'プロフィールを更新しました！',
    settingsTitle: '⚙️ 設定',
    changeEmail: 'メールアドレス変更',
    newEmailPlaceholder: '新しいメール',
    changeButton: '変更',
    emailUpdateSent: 'メールアドレス変更の確認メールを送信しました。新しいメールアドレスで確認してください。',
    emailSameError: '新しいメールアドレスは現在のメールアドレスと同じです。',
    invalidEmailError: '有効なメールアドレスを入力してください。',
    passwordTitle: 'パスワード',
    passwordResetLink: 'パスワードリセットはこちら →',
    dangerZoneTitle: '危険な操作',
    deleteAccountButton: 'アカウントを削除する',
    deleteConfirmText: '本当に削除しますか？',
    deleteConfirmButton: '削除',
    deleteCancelButton: '戻る',
    deleteFailed: 'アカウントの削除に失敗しました: ',
    fetchDataFailed: 'クイズデータの取得に失敗しました: ',
    analyzing: '分析中...',
    noWeakShortcuts: '完璧です！苦手なショートカットは見つかりませんでした。',
    accuracy: '正解率',
    mistakes: 'ミス {wrong} / {total} 挑戦',
    startDrill: '苦手克服ドリルを開始',
    noSessions: '最近のクイズセッションはありません。',
    noStats: 'まだクイズをプレイしていません。',
    app: 'アプリケーション',
    sessions: 'セッション',
    sessionsShort: 'セッション',
    lastPlayed: '最終プレイ',
    difficulty: '難易度',
    score: 'スコア',
    correctCount: '正解数 / 問題数',
    date: '日時',
    details: '詳細',
    overallAccuracy: '総合正解率',
    correct: '正解',
    totalSessions: '総セッション数',
    completedQuizzes: '完了したクイズ数',
    totalAnswers: '回答総数',
    questionsSolved: 'これまでに解いた問題',
    questionsSolvedShort: '問題',
  },

  // Session Detail Modal
  sessionDetail: {
    title: 'クイズセッション詳細',
    failedToFetch: 'セッション詳細の取得に失敗しました: ',
    summary: 'サマリー',
    accuracy: '正解率:',
    correctAnswers: '正解数:',
    history: '回答履歴',
    noHistory: '回答履歴がありません',
    table: {
      shortcut: 'ショートカット',
      description: '説明',
      result: '結果',
      time: '回答時刻',
    },
    resultCorrect: '✓ 正解',
    resultIncorrect: '✗ 不正解',
  },

  // System Shortcut Warning
  systemShortcutWarning: {
    modalTitle: 'macOSシステムショートカットについて',
    buttonTitle: 'macOSシステムショートカットの設定について',
    description: 'macOSのシステムショートカット（<code>Ctrl + F2</code>など）は、Webアプリケーションでは無効化できません。',
    solutionTitle: '以下の方法で競合を解決できます：',
    method1Title: '方法1: フルスクリーンモードを使用',
    method1Desc: 'アプリを<strong>フルスクリーンモード</strong>にすることで、一部のショートカットをキャプチャできます。右上の全画面ボタンをクリックしてください。',
    method2Title: '方法2: システム設定で無効化',
    method2Step1: 'システム設定 → キーボード → キーボードショートカット を開く',
    method2Step2: '左側のメニューから該当するカテゴリを選択：',
    method2Categories: {
      missionControl: 'Mission Control',
      launchpad: 'Launchpad',
      keyboard: 'キーボード',
      screenshots: 'スクリーンショット',
    },
    method2Step3: '使用しないショートカットのチェックを外す',
    commonConflictsTitle: '主な競合ショートカット',
    canBeDisabledHint: 'これらは「システム設定」で無効化できます',
    securityHint: '💡 <strong>ヒント:</strong> セキュリティ関連のショートカット（<code>Cmd + Option + Escape</code>、<code>Ctrl + Cmd + Q</code>など）は、OSによって保護されており無効化できません。',
  },

  // Common
  common: {
    loading: '読み込み中...',
    error: 'エラー',
    success: '成功',
    cancel: 'キャンセル',
    confirm: '確認',
    save: '保存',
    delete: '削除',
    edit: '編集',
    close: '閉じる',
    back: '戻る',
    retry: '再試行',
    next: '次へ',
    previous: '前へ',
    search: '検索',
    filter: 'フィルター',
    sort: '並び替え',
    all: 'すべて',
    none: 'なし',
    yes: 'はい',
    no: 'いいえ',
    ok: 'OK',
  },

  // Errors
  errors: {
    notFound: 'ページが見つかりません',
    serverError: 'サーバーエラー',
    networkError: 'ネットワークエラー',
    unknownError: '不明なエラー',
    tryAgain: 'もう一度お試しください',
    failedToFetch: 'データの取得に失敗しました',
    checkConnection: 'インターネット接続を確認するか、しばらく経ってから再度お試しください。',
  },

  // Home Page
  home: {
    loadingTitle: 'キーボードショートカットを読み込み中...',
    loadingSubtitle: 'データを準備しています。少々お待ちください。',
  },

  // Release Notes
  releaseNotes: {
    title: 'リリースノート',
    subtitle: 'Keyboard Visualizerの最新アップデートと改善履歴',
    backToHome: '← ホームに戻る',
    categories: {
      feature: '新機能',
      improvement: '改善',
      fix: 'バグ修正',
      breaking: '破壊的変更',
    },
  },
};
